import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router';

import { ListItem } from 'material-ui/List';

import SchoolIcon from 'material-ui/svg-icons/social/school';
import SubjectIcon from 'material-ui/svg-icons/action/subject';
import LaunchIcon from 'material-ui/svg-icons/action/launch';
import VideoIcon from 'material-ui/svg-icons/av/video-library';
import AudioIcon from 'material-ui/svg-icons/av/library-music';
import LibraryIcon from 'material-ui/svg-icons/av/library-books';
import PrivateIcon from 'material-ui/svg-icons/action/lock';
import SkillIcon from 'material-ui/svg-icons/social/public';
import CPDIcon from 'material-ui/svg-icons/toggle/star';
import DoneIcon from 'material-ui/svg-icons/action/done';
import DoneAllIcon from 'material-ui/svg-icons/action/done-all';
import SettingsIcon from 'material-ui/svg-icons/action/settings';
import IconMenu from 'material-ui/IconMenu';
import IconButton from 'material-ui/IconButton';
import InfoIcon from 'material-ui/svg-icons/action/info';
import MoreVertIcon from 'material-ui/svg-icons/navigation/more-vert';
import SpotIcon from 'material-ui/svg-icons/image/lens';

import LinearProgress from 'material-ui/LinearProgress';

import { statusColours } from '../../constants/ColourConstants';

import ROLES from '../../constants/Roles';
import buildContextMenu from '../Common/BuildContextMenu';

const style = {
    menu: {
        marginRight: 0,
        marginBottom: 0,
        float: 'left',
        position: 'relative',
        zIndex: 0,
    },
    menuItem: {
        color: '#CC0000',
    },
    iconButton: {
        marginRight: 0,
    },
    listItem: {
        padding: '2px',
    },
    icon: {
        height: '32px',
        width: '32px',
    },
    iconSmall: {
        height: '16px',
        width: '16px',
        margin: '2px 8px 0 0',
        padding: 0,
        color: statusColours.medium,
    },
};

class CourseModuleListItem extends Component {

    getActions(row) {
        const infoLink     = '/dashboard/module/' + row.id;
        const settingsLink = '/dashboard/module/' + row.id + '/settings';

        return [
            {
                link: infoLink,
                label: 'Preview',
                icon: <InfoIcon />
            },
            {
                type:'divider'
            },
            {
                link: settingsLink,
                label: 'Settings',
                icon: <SettingsIcon />,
                condition: {
                    show: this.context.auth.canEdit(row.access),
                    roles: [ROLES.ADMIN]
                }
            },
        ];
    };

    render() {

        const row = this.props.data;
        const infoLink = this.props.link || `/dashboard/module/${row.id}`;
        const actions = (this.props.actions || this.getActions(row));
        const menuItems = buildContextMenu(actions, this.context.auth);

        let displayDuration = '';
        const duration =  parseInt(row.duration);
        if (duration > 0) {
            let hours = Math.floor( duration / 60);
            let minutes = duration % 60;

            if (hours > 0) {
                displayDuration = hours + 'h';
                if (minutes > 0) {
                    displayDuration += ' ' + minutes + 'm';
                }
            } else if (minutes > 0) {
                displayDuration = minutes + 'm';
            }
            displayDuration += ' - ';
        }

        let iconColor = statusColours.default;
        let avatarIcon = (<SubjectIcon color={iconColor} />);
        let description = '';
        let statusLine  = '';

        let listItemProps = {
            key: row.id,
            style: style.listItem
        };


        //
        // TODO: refactor spots 
        // if (row.enrolmentIsAssigned) {
        //     spot = row.enrolmentIsMandatory
        //         ? (<span className="spot spot-mandatory" title="mandatory"/>)
        //         : (<span className="spot spot-optional" title="optional"/>);
        // }
        //

        listItemProps.primaryText = (
            <Link to={infoLink} className="primaryText">
                {row.name}
            </Link>
        );

        statusLine += displayDuration;

        if (row.requirement) {
            statusLine += ` [ ${Number(row.enrolmentScore)} / ${row.requirement} ] - `;
        }


        let iconGroup = [];
        if (row.visibility === 'private') {
            iconGroup.push(<PrivateIcon className="icon-small" key="visibility" />);
        }

        if (row.skillId) {
            iconGroup.push(<SkillIcon className="icon-small" key="skill" />);
        }

        if (Number(row.cpdCredits)) {
            iconGroup.push(<CPDIcon className="icon-small" key="cpd" />);
        }

        if (Number(row.mandatory)) {
            iconGroup.push(<SpotIcon className="icon-small" color={statusColours.mandatory} key="mandatory"/>);
        }


        switch(row.enrolmentStatus) {

            case 'waiting':
                description  = 'On waiting list';
                break;

            case 'enrolled':
                description  = row.enrolmentIsAssigned ? 'Assigned' : 'Booked';
                iconGroup.push(<DoneIcon className="icon-small"  color={statusColours.default} key="enrolled" />);

                if (!!row.enrolmentDate) {
                    const enrolmentDate = new Date(row.enrolmentDate);
                    if (!!enrolmentDate && !isNaN(enrolmentDate.valueOf())) {
                        description += ` on ${enrolmentDate.toDateString()}`;
                    }
                }

                break;

            case 'completed':

                description = 'Completed';
                iconColor = statusColours.completed;
                if (!!row.dateCompleted) {
                    const completedDate = new Date(row.dateCompleted);
                    if (!!completedDate && !isNaN(completedDate.valueOf())) {
                        description += ` on ${completedDate.toDateString()}`;
                    }
                }

                let passed  = false;

                if (row.type === 'resource' || row.type === 'video' || row.type === 'audio') {
                    passed = true;
                } else {

                    if (row.required > 0) {

                        if (row.enrolmentScore && row.enrolmentScore >= row.required) {
                            passed = true;
                            description = 'Passed';
                        }

                    } else {
                        passed = true;
                        description = 'Passed';
                    }
                }

                if (passed) {
                    iconColor = statusColours.passed;
                    iconGroup.push(<DoneAllIcon className="icon-small" color={statusColours.primary} key="done" />);
                } else {
                    iconGroup.push(<DoneIcon className="icon-small" color={statusColours.primary } key="done" />);
                }

                break;

            case 'cancelled':
                iconColor = statusColours.cancelled;
                description = 'Cancelled';
                break;

            default:
                break;
        }

        if (row.loading) {
            listItemProps.secondaryText = <div><LinearProgress mode="indeterminate"/></div>;
        } else {
            listItemProps.secondaryText = <Link to={infoLink} className="secondaryText">
                <em>{statusLine}{description}</em>
                <br />
                {iconGroup}
            </Link>;
            listItemProps.secondaryTextLines = 2;

        }

        if (menuItems.length > 0) {
            const topRight = {horizontal: 'right', vertical: 'top'};
            const iconMenuProps = {
                menuStyle: style.menu,
                anchorOrigin: topRight,
                targetOrigin: topRight,
            };

            listItemProps.rightIcon = (
                <IconMenu {...iconMenuProps}
                    iconButtonElement={(
                        <IconButton touch={true} >
                            <MoreVertIcon color={statusColours.light} style={style.iconButton} />
                        </IconButton>
                    )}
                >
                    {menuItems}
                </IconMenu>
            );
        }

        switch(row.type) {

            case 'classroom':
                avatarIcon = (<SchoolIcon style={style.icon} color={iconColor} />);
                break;

            case 'e-learning':
                avatarIcon = (<LaunchIcon style={style.icon} color={iconColor} />);
                break;

            case 'video':
                avatarIcon = (<VideoIcon style={style.icon} color={iconColor} />);
                break;

            case 'audio':
                avatarIcon = (<AudioIcon style={style.icon} color={iconColor} />);
                break;

            case 'resource':
                avatarIcon = (<LibraryIcon style={style.icon} color={iconColor} />);
                break;

            default:
                break;
        }

        return (
                <ListItem
                    key={row.id}
                    style={style.listItem}
                    leftAvatar={
                        <Link to={infoLink}>
                            {avatarIcon}
                        </Link>
                    }
                    {...listItemProps}
                />
        )
    }
}

CourseModuleListItem.contextTypes = {
    auth: PropTypes.object.isRequired
};

export default CourseModuleListItem;
